import { Editor, EditorPlugin } from 'roosterjs-editor-core';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';

export default class TxpContentPlugin implements EditorPlugin {
    private editor: Editor;

    constructor(private viewState: EditorViewState) {}

    public getName() {
        return 'TxpContent';
    }

    public initialize(editor: Editor) {
        this.editor = editor;
    }

    public dispose() {
        this.editor = null;
    }

    public getTextContent() {
        return this.editor && this.viewState.isDirty && this.editor.getTextContent();
    }
}
